module.exports = __webpack_public_path__ + "img/ico-book-user.54ae2c64.svg";